import { useMemo } from "react";

import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { StackSuggestions } from "constants/stack";

import useCellFilterAction from "../useCellFilterAction";

const StacksTableSpaceCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const spaceFilterAction = useCellFilterAction({
    filterName: StackSuggestions.Space,
    filterValue: stack.spaceDetails.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <SpacePath spaceId={stack.spaceDetails.id} fallbackName={stack.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default StacksTableSpaceCell;
